export const sv = {
  colVehicle: 'Fordon',
  colPrice: 'Pris',
  colStatus: 'Status',
  colSent: 'Skickad',
  hasInspectionReport: 'Har besiktningsprotokoll',
  hasWorkOrder: 'Har arbetsorder',
  inclVat: 'inkl. moms',
  title: 'Offerter',
  subtitle: 'Hantera dina skickade offerter',
  statTotal: 'Totalt',
  statPending: 'Väntande',
  statAccepted: 'Accepterade',
  statConversion: 'Konvertering',
  errorHeading: 'Fel vid hämtning av offerter',
  errorGeneric: 'Ett fel inträffade',
  searchPlaceholder: 'Sök på registreringsnummer...',
  statusAll: 'Alla statusar',
  statusPending: 'Väntande',
  statusAccepted: 'Accepterade',
  statusRejected: 'Avvisade',
  tableTitle: 'Dina offerter',
  emptyMessage: 'Inga offerter hittades',
  emptyDetail: 'Det verkar som att det inte finns några offerter för detta garage än.',
}

export const en: typeof sv = {
  colVehicle: 'Vehicle',
  colPrice: 'Price',
  colStatus: 'Status',
  colSent: 'Sent',
  hasInspectionReport: 'Has inspection report',
  hasWorkOrder: 'Has work order',
  inclVat: 'incl. VAT',
  title: 'Quotes',
  subtitle: 'Manage your sent quotes',
  statTotal: 'Total',
  statPending: 'Pending',
  statAccepted: 'Accepted',
  statConversion: 'Conversion',
  errorHeading: 'Error fetching quotes',
  errorGeneric: 'An error occurred',
  searchPlaceholder: 'Search by registration number...',
  statusAll: 'All statuses',
  statusPending: 'Pending',
  statusAccepted: 'Accepted',
  statusRejected: 'Rejected',
  tableTitle: 'Your quotes',
  emptyMessage: 'No quotes found',
  emptyDetail: 'It looks like there are no quotes for this garage yet.',
}
